import Parse from '@/plugins/parse'

const state = {
  id: '',
  password: ''
}

const mutations = {
  setId (state, id) {
    state.id = id
  },

  setPassword (state, password) {
    state.password = password
  }
}

const actions = {
  async exec ({ dispatch }) {
    const user = new Parse.User()
    user.setUsername(state.id)
    user.setPassword(state.password)

    try {
      dispatch('loading/show', null, { root: true })
      await user.logIn()
      dispatch('loading/hide', null, { root: true })
      dispatch(
        'toast/show',
        'ログインしました',
        { root: true }
      )
      return true
    } catch (error) {
      console.log(error.code, error)
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
